export enum PlanningRoutesEnum{
    PLANNING_PREFIX = 'planning_time-filters',
    PLANNING_TIME   = 'planning_time-map',

    PLANNING_TRACK_FILTERS = 'planning_track-filters',
    PLANNING_TRACK         = 'planning_track-map',
}